import { css } from "@emotion/react";

export const radioStyles = ({ theme, darkBackground }) => css`
    .ginput_container_radio li {
        display: flex;
        align-items: center;

        label {
            font-size: 1.5rem;
            font-weight: 900;
            color: ${darkBackground
                ? theme.colors.typography.defaultDarkBackground
                : theme.colors.typography.defaultLightBackground};

            a {
                color: ${darkBackground
                    ? theme.colors.typography.defaultDarkBackground
                    : theme.colors.typography.defaultLightBackground};
                text-decoration: underline;
            }
        }

        &:not(:last-child) {
            margin-bottom: 15px;
        }
    }

    .gravityform__field__input__radio {
        appearance: none;
        height: 18px;
        width: 18px;
        background-color: ${theme.palette.white};
        border-radius: 50%;
        outline: 1px solid
            ${darkBackground
                ? theme.colors.typography.defaultDarkBackground
                : theme.colors.typography.defaultLightBackground};
        margin: 0 5px 0 1px;

        &:checked {
            border: 3px solid ${theme.palette.white};
            background-color: ${theme.palette.lightBlue};
        }

        &:focus {
            + label {
                outline: 1px solid ${theme.palette.lightBlue};
            }
        }
    }
`;
